import React from 'react';
import { usePublicOptOut } from './hooks/usePublicOptOut';
import { BroadcastPreferencePage } from './BroadcastPreferencePage';

export const OptOut = () => {
  const { optOut, isLoading, isSuccess, isError, error } = usePublicOptOut();

  return (
    <BroadcastPreferencePage
      onSubmit={optOut}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      successContent={{
        title: 'You have unsubscribed from SmPC update notifications',
        message: 'Your preferences will be saved, and you will not receive SmPC updates.',
        linkText: 'Re-Subscribe',
        linkAction: 'opt-in',
      }}
      invalidTokenContent={{
        title: 'Invalid Link',
        message: 'This opt-out link is invalid or has expired. Please check the link in your email or contact your administrator.',
      }}
      actionLabel="opt-out"
    />
  );
};
